import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './sellNowPage.css'; // Ensure this CSS file exists
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';
import '../home/homePage.css';
import productImage from '../../assets/images/1.jpg'; // Placeholder if product image is missing
import { useUser } from '../../contexts/userContext';
import { useCart } from '../../contexts/cartContext';
import { render } from '@testing-library/react';

interface Category {
    cat_id: number;
    title: string;
    // parent_title: string | null;
    children?: Category[];
    slug: string;
}
interface SellNowState {
    [key: number]: boolean; // Product ID as key and boolean (true/false) as value
}

const generateSessionCode = () => {
    return Math.random().toString(36).substr(2, 9) + Date.now();
};

interface Product {
    product_id: number;
    cat_id: number;
    title: string;
    is_active: number;
    base_value: string;
    img_name: string;
    unit_type: number;
    tag_page: number | null;
    working_price: string | null;
    notworking_price: string | null;
    sess_code: string;
    parent_cat_id: number;
    qty: number,
    brands: any,
    brand: any;
}

const Sidebar: React.FC<{ categories: Category[], onSelectCategory: (cat_id: number) => void }> = ({ categories, onSelectCategory }) => {

    const renderCategories = (categories: Category[], level = 0) => {
        return (
            <ul className={`category-level-${level}`}>
                {categories.map(category => (
                    <li key={category.cat_id}>
                        <div
                            onClick={() => onSelectCategory(category.cat_id)}
                            className="category-title"
                            style={{ cursor: 'pointer', paddingLeft: `${level * 10}px` }}
                        >
                            {category.title}
                        </div>
                        {/* Render child categories recursively */}
                        {category.children && category.children.length > 0 && (
                            renderCategories(category.children, level + 1)
                        )}
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <div className="sidebar">
            {renderCategories(categories)}
        </div>
    );
};
const SellNowPage: React.FC<{ category?: any }> = ({ category }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const [errorQtys, setErrorQtys] = useState<{ [key: number]: string | null }>({});

    const [sessionCode, setSessionCode] = useState<string>('');
    const [categories, setCategories] = useState<Category[]>([]);
    const [products, setProducts] = useState<Product[]>([]);
    const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);
    const [quantities, setQuantities] = useState<{ [productId: number]: number | null }>({});
    const [showPincodePopup, setShowPincodePopup] = useState<boolean>(false);
    const [pincode, setPincode] = useState<string>('');
    const [address, setAddress] = useState<string | null>(null);
    const [brands, setBrands] = useState<{ [key: number]: any[] }>({});
    const [dropdownOpen, setDropdownOpen] = useState<{ [key: string]: boolean }>({});
    const [isCategoriesVisible, setCategoriesVisible] = useState(false);
    const [selectedBrands, setSelectedBrands] = useState<{ [key: string]: string | null }>({});
    const [brandSelectionError, setBrandSelectionError] = useState<{ [key: string]: boolean }>({});
    const [brandTitle, setBrandTitle] = useState<string | null>(null);
    const [sellNowState, setSellNowState] = useState<SellNowState>({});
    const [brandError, setBrandError] = useState<Record<string, boolean>>({});
    const query = new URLSearchParams(location.search);

    const [loading, setLoading] = useState(true);
    const { fetchCartQuantity } = useCart();
    const {
      user_id,
      city_name,
      setUtmSessionId,
      checkSessionTokenExpirationStatus,
      handleRemoveLocalStorage,
    } = useUser();
    const { cartQuantity,setCartQuantity ,handleQuantity} = useCart();
    const { setcityName, globalSearchTerm, setGlobalSearchTerm, setUserId, setUsername,fetchCsrfToken } = useUser();
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const version = process.env.REACT_APP_VERSION;

    const utmSource = query.get('utm_source');

    // Generate utm_session_id if UTM parameters are present

    //console.log("------------11111111111111111", category)



    function generateUtmSessionId(length = 24) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters[randomIndex];
        }

        return result;
    }



    // if (!city_name) {
    //     alert('please Choose your location.')
    //     // cityNameSelected = 'Select city'
    // }

    useEffect(() => {
        const code = sessionStorage.getItem('session_code') || generateSessionCode();
        sessionStorage.setItem('session_code', code);
        setSessionCode(code);
        if (utmSource) {
            // Usage
            const utmSessionId = generateUtmSessionId();// Simple session ID generator
            //console.log("00000000000", utmSessionId)
            setUtmSessionId(utmSessionId)
            query.set('utm_session_id', utmSessionId); // Add utm_session_id to query
        }
        // Define an async function to generate the cart and then fetch other data
        const initialize = async () => {
            try {
                // Generate cart
                const response = await fetch(`${backendUrl}api/v2/session-cart/${code}`);
                // Optionally handle response from generateCart here
                // if (!response.ok) {
                //     throw new Error('Failed to generate cart');
                // }

                // Fetch categories and products after cart generation
                const url = window.location.href;
                const commonPart = 'sell-';
                const slug = url.split(`${commonPart}`)[1];
                const cat_id = null
                await fetchCategories();

                //console.log("------------>>>>>>>>", slug)
                if (slug) {
                    //console.log("--------->>>>>>>>>slug------")
                    await handleCategorySelect(cat_id)
                } else {
                    await fetchProducts();
                }

            } catch (error) {
                //console.error('Error initializing:', error);
                setError('Failed to initialize');
            }
        };
        // Call the async function
        initialize();
    }, []);

    useEffect(() => {
        if (category) {
            fetchCategories();
        }
        fetchCategories();
        // ...other logic
    }, [category]);



    // Define fetchCategories and fetchProducts outside of useEffect
    const fetchCategories = async () => {
        try {
            const response = await fetch(`${backendUrl}${version}product-categories`);
            if (!response.ok) {
                throw new Error('Failed to fetch categories');
            }
            const data = await response.json();
            //console.log("data---------------", data);
            setCategories(data.data);
        } catch (error) {
            //console.error('Error fetching categories:', error);
            setError('Failed to load categories');
        }
    };

    const fetchProducts = async () => {
        try {

            const session_code = sessionStorage.getItem('session_code'); // Retrieve session code from sessionStorage
            // If session_code is not null, hit the products-qty API
            const response = await fetch(`${backendUrl}${version}products-qty/${session_code}/${city_name}?${query.toString()}`);
            if (!response.ok) {
                throw new Error('Failed to fetch products');
            }
            const data = await response.json();

            setProducts(data.data);
            setFilteredProducts(data.data);
            // Extract all unique parent_cat_ids from the products
            const uniqueParentCatIds = [...new Set(data.data.map((product: any) => product.parent_cat_id))];
            // Fetch brands for each unique parent_cat_id
            uniqueParentCatIds.forEach((parent_cat_id: any) => {
                fetchBrands(parent_cat_id); // Fetch brands for each parent category
            });
        } catch (error) {
            setError('Failed to load products');
        }
    };

    const handleCategorySelect = async (cat_id: any) => {
        try {
            setLoading(true);

            // Extract slug from the current URL
            const url = window.location.href;
            const commonPart = 'sell-used/';
            const slug = url.split(`${commonPart}`)[1]; // Get everything after 'sell-used-'

            // if (!slug) {
            //     throw new Error('Slug not found in the URL');
            // }

            //console.log("Slug extracted from URL:", slug);

            if (cat_id) {
                const response = await fetch(`${backendUrl}${version}All-product/${cat_id}`);
                const data = await response.json();
                setFilteredProducts(data.data);
                if (data.data && data.data.length > 0) {
                    const parent_cat_id = data.data[0].parent_cat_id;
                    fetchBrands(parent_cat_id);
                    // Update the window history with the new slug from the response
                    const responseSlug = data.data[0].parent_slug; // Assuming slug is in the first item
                    //console.log('Navigating to:', `/sell-used-${responseSlug}`);
                    window.history.pushState({}, '', `/sell-used/${responseSlug}`);
                }
            } else {
                const response = await fetch(`${backendUrl}${version}product-slug/${slug}`);
                const data = await response.json();
                setFilteredProducts(data.data);
                if (data.data && data.data.length > 0) {
                    const parent_cat_id = data.data[0].parent_cat_id;
                    fetchBrands(parent_cat_id);
                }
                // Update the window history with the new slug
                //console.log('Navigating to:', `/sell-used-${slug}`);
                window.history.pushState({}, '', `/sell-used/${slug}`);
            }

        } catch (error: any) {
            //console.error('Error fetching filtered products:', error);
            setError('Failed to load filtered products');
        } finally {
            setLoading(false); // Set loading to false after fetching data
        }
    };
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const catId = queryParams.get('cat_id');

        if (catId) {
            handleCategorySelect(Number(catId));
            // <CategorySelector />
            fetchBrands(Number(catId))
        }
    }, [location.search]);

    const fetchBrands = async (parent_cat_id: number) => {
        try {
            const response = await fetch(`${backendUrl}api/v2/brands/${parent_cat_id}`);
            const result = await response.json();
            if (result.data.length > 0) {

                setBrands((prev) => ({

                    ...prev,

                    [parent_cat_id]: result.data,

                }));

            } else {

                setBrands((prev) => ({

                    ...prev,

                    [parent_cat_id]: [], // Ensure empty array if no brands

                }));

            }
        } catch (error) {
            //console.error('Error fetching brands:', error);
        }
    };

    const handleBrandSelect = (parentCatId: number, productId: number, brandTitle: string) => {
        const uniqueKey = `${parentCatId}-${productId}`;
        setSelectedBrands(prevState => ({
            ...prevState,
            [uniqueKey]: brandTitle,
        }));
        setBrandTitle(brandTitle)
        setDropdownOpen(prevState => ({
            ...prevState,
            [uniqueKey]: false, // Close dropdown after selection
        }));
        if (brandTitle !== "") {
            setBrandError((prev) => ({
                ...prev,
                [uniqueKey]: false
            }));
        }
    };
    const handleViewClick = () => {
        setCategoriesVisible(!isCategoriesVisible);
    };

    const fetchProductsByCategory = async (cat_id: number) => {
        try {
            const response = await fetch(`${backendUrl}api/v2/product/${cat_id}`);
            if (!response.ok) throw new Error('Failed to fetch products');
            const data = await response.json();

            // setFilteredProducts(data.data);
            return (data.data)
        } catch (error) {
            //console.error('Error fetching products by category:', error);
        }
    };

    const handleSellNowClick = (productId: number, product: any) => {
        const returnUrl = window.location.pathname;
        const uniqueKey = `${product.parent_cat_id}-${productId}`;
        const selectedBrand = selectedBrands[uniqueKey];
        //console.log("--------------user-id-summary-page", brands[product.parent_cat_id]?.length > 0 && brands[product.cat_id]?.length > 0 && !selectedBrand)
        if (!selectedBrand) {
            // Show a message if brands are available but none is selected
            setBrandError((prevState) => ({
                ...prevState,
                [uniqueKey]: true // Show error for this particular product
            }));
        }
        else if (!user_id || user_id == null) {
            handleAddToCart(product, 1, brandTitle);
            navigate('/login', { state: { returnUrl, user_id: user_id, session_code: sessionCode, productId: productId, product: product } });
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } else {
            handleAddToCart(product, 1, brandTitle);
            navigate('/order-summary', { state: { user_id: user_id, session_code: sessionCode, productId: productId, product: product } });
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    };

    const handleAddToCartClick = (productId: number, product: any) => {

        const uniqueKey = `${product.parent_cat_id}-${productId}`;
        const selectedBrand = selectedBrands[uniqueKey];
        //console.log("--------------user-id-summary-page", brands[product.parent_cat_id]?.length > 0, brands[product.cat_id]?.length > 0, !selectedBrand)

        if (!selectedBrand) {
            setBrandError((prevState) => ({
                ...prevState,
                [uniqueKey]: true // Show error for this particular product
            }));
            // Show a message if brands are available but none is selected
            // alert('Please select a brand first.');
        } else {
            // Clear any brand selection errors
            setBrandSelectionError({ [uniqueKey]: false });

            // Mark the product as in "sell now" mode
            setSellNowState((prevState) => ({
                ...prevState,
                [productId]: true
            }));

            // Update the quantity for the product
            setQuantities((prevQuantities) => ({
                ...prevQuantities,
                [productId]: 1 // Initially set to 1 when added to cart
            }));
            // Add product to cart with the initial quantity
            handleAddToCart(product, 1, brandTitle);
            // Ensure re-render by using a timeout (if state doesn't update immediately)
            setTimeout(() => {
                setSellNowState((prevState) => ({
                    ...prevState,
                    [productId]: true
                }));
            }, 100); // Add a slight delay to force re-render if necessary
        }
    };

    const handleIncrease = (productId: number, product: any, brandName: any) => {
        setQuantities(prevQuantities => {
            // Get the current quantity
            const currentQuantity = prevQuantities[productId] ?? Number(product.qty);
            const newQuantity = currentQuantity + 1; // Increment the quantity

            // Check if new quantity exceeds the limit
            if (newQuantity > 5) {
                setErrorQtys(prev => ({ ...prev, [productId]: 'Cannot add more than 5 items of this product.' })); // Set error message for this product
                return prevQuantities; // Return the previous state without changes
            } else {
                setErrorQtys(prev => ({ ...prev, [productId]: null })); // Clear error if within limit for this product
            }

            // If it's within the limit, call handleAddToCart with the updated quantity
            handleAddToCart(product, newQuantity, brandName);
            return {
                ...prevQuantities,
                [productId]: newQuantity,
            };
        });
    };


    const handleAddToCart = async (product: Product, quantity: number, brandName: any) => {
        // Get the current quantity from state
        const currentQuantity = quantities[product.product_id] ?? 0;
        const newQuantity = quantity; // We already validated the quantity in handleIncrease

        if (newQuantity > 0) {
            try {
                const csrfToken = await fetchCsrfToken();
                const response = await fetch(`${backendUrl}${version}add-to-cart`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': csrfToken,
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        product_id: product.product_id,
                        title: product.title,
                        base_value: product.base_value,
                        working_price: product.working_price,
                        notworking_price: product.notworking_price,
                        quantity: newQuantity,
                        sess_code: sessionCode,
                        brand: brandTitle || brandName,
                    }),
                });

                const data = await response.json();
                //console.log('Product added to cart:', newQuantity);

                // Update cart quantity
                await fetchCartQuantity(sessionCode);
            } catch (error) {
                //console.error('Error adding product to cart:', error);
            }
        } else {
            // Handle case where quantity is 0 or less
            //console.log('Quantity is zero or less, not adding to cart');
        }
    };

    const handleDecrease = (productId: number, product: Product) => {
        setQuantities(prevQuantities => {
            // Calculate the new quantity, ensuring it doesn't go below 0
            const newQuantity = Math.max((prevQuantities[productId] || 1) - 1, 0);

            // If the new quantity is 0, remove the product from the quantities state
            if (newQuantity === 0) {
                const { [productId]: _, ...rest } = prevQuantities;
                return rest;
            }

            // Clear error message if the quantity is below 5
            if (newQuantity < 5) {
                setErrorQtys(prev => ({ ...prev, [productId]: null })); // Clear the error message if quantity is less than 5
            }

            // Otherwise, update the quantity for the product
            return {
                ...prevQuantities,
                [productId]: newQuantity,
            };
        });

        // Call decreaseItemQuantity to perform any side-effects related to decreasing quantity
        decreaseItemQuantity(productId, product.base_value);
    };


    const decreaseItemQuantity = async (product_id: number, base_value: any) => {
        try {
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(`${backendUrl}${version}remove-from-cart`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken,
                },
                credentials: "include",
                body: JSON.stringify({
                    sess_code: sessionCode,
                    product_id,
                    base_value,
                }),
            });
            if (response.ok) {
                // Only update cart quantity by quantityChange (-1 here)
                await fetchProducts();
                await fetchCartQuantity(sessionCode)
            } else {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to update cart item quantity');
            }
        } catch (error) {
            //console.error('Error updating cart item quantity:', error);
        }
    };
    const selectPincode = async () => {
        try {
            const response = await fetch(`${backendUrl}${version}pincode/${pincode}`);
            const data = await response.json();
            if (data.data) {
                const { city, state } = data.data;
                setAddress(`${city}, ${state}`); // Update state with pincode data
                setProducts(data.data);
                setFilteredProducts(data.data);
                setShowPincodePopup(false);
            } else {
                setError('Pincode is Invalid');
            }
        } catch (error) {
            setError('Failed to load products');
        }
    };
    const handleGoToCart = async (product: any) => {
        navigate('/cart/listing', { state: { sess_code: sessionCode, user_id: user_id, product: product } })
    }

    useEffect(() => {
        const isSessionHandled = sessionStorage.getItem("sessionHandled");
      
        // If the session was already handled, avoid running this logic again
        if (isSessionHandled) return;
      
        // console.log("------>>>>>>>>>>>>>>>>>aboutus-------", checkSessionTokenExpirationStatus());
      
        if (checkSessionTokenExpirationStatus()) {
          // Clear session-related operations
          handleQuantity();
          handleRemoveLocalStorage();
      
          // Set the sessionHandled flag to true to prevent re-execution after reload
          sessionStorage.setItem("sessionHandled", "true");
      
          // Redirect to the homepage
          navigate("/");
      
          // Reload the page to clear cache
          window.location.reload();
        }
      }, []);
    return (
        <div>
            <Header /> {/* Pass address to Header */}
            <main className="main-content-sell-now-page">
                <div className="sidebar-container">
                    {error && <p className="error">{error}</p>}
                    {!error && categories.length > 0 && (
                        <Sidebar categories={categories} onSelectCategory={handleCategorySelect} />
                    )}
                </div>
                {/* Mobile Dropdown */}
                <div className="MOBILE-VIEW-DROPDOWN">
                    <button className="view-button" onClick={handleViewClick}>
                        View
                    </button>
                    {isCategoriesVisible && (
                        <>
                            {error && <p className="error">{error}</p>}
                            {!error && categories.length > 0 && (
                                <Sidebar categories={categories} onSelectCategory={handleCategorySelect} />
                            )}
                        </>
                    )}
                </div>
                {/* Product Container */}
                <div className="product-container">

                    <div className="product-list-container">
                        <div className="heading-section">
                            <h1 className="heading">Select Products to Sell</h1>
                        </div>
                        {/* Loader or Empty Message */}
                        {filteredProducts.length === 0 ? (
                            <div className="empty-cart-message">
                                <div className="loader"></div> {/* Loader animation */}
                            </div>
                        ) : (
                            <div className="product-list">
                                {filteredProducts.map((product) => (
                                    <div key={product.product_id} className="product-item">
                                        <img
                                            src={`./${product.img_name}`}
                                            alt={product.title}
                                            onError={(e: any) => {
                                                e.target.onerror = null; // Prevent infinite loop
                                                e.target.src = productImage; // Fallback image
                                            }}
                                        />
                                        <h2>{product.title}</h2>
                                        <div className="inside-product-container">
                                            <div>
                                                <p>₹ {parseFloat(product.base_value)}</p>
                                                {/* Brand Dropdown */}
                                                {product?.brands && product.brands.length > 0 ? (
                                                    <div className='select-brand-option'>
                                                        <select
                                                            className={`select-brand ${brandError[`${product.parent_cat_id}-${product.product_id}`] ? 'errors' : ''}`} // Add error class conditionally
                                                            value={selectedBrands[`${product.parent_cat_id}-${product.product_id}`] || ''}
                                                            onChange={(e) =>
                                                                handleBrandSelect(product.parent_cat_id, product.product_id, e.target.value)
                                                            }
                                                        >
                                                            {/* Placeholder option */}
                                                            <option className='disable-selection' value="" disabled>
                                                                {product?.brand || "Select Brand"}
                                                            </option>


                                                            {/* Render the available brands */}
                                                            {product.brands.map((brand: any, index: number) => (
                                                                <option key={index} value={brand.title}>
                                                                    {brand.title}
                                                                </option>
                                                            ))}
                                                            <span className="custom-dropdown-icon">
        {/* Replace with your icon, e.g., an SVG or FontAwesome icon */}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 10l5 5 5-5H7z" />
        </svg>
    </span>
                                                        </select>

                                                        {/* Show error message if no brand is selected */}
                                                        {brandError[`${product.parent_cat_id}-${product.product_id}`] && (
                                                            <p className='error-brand-title'>
                                                                Please select a brand.
                                                            </p>
                                                        )}
                                                    </div>


                                                ) : (
                                                    <div className='select-brand-option'>

                                                    </div>
                                                )}

                                            </div>


                                            <div className="sell-now-container">
                                                {(sellNowState[product.product_id] || product.qty >= 1) &&
                                                    (quantities[product.product_id] ?? product.qty) >= 1 ? (
                                                    <div className="quantity-control">
                                                        <button
                                                            className="decrease-button"
                                                            onClick={() => handleDecrease(product.product_id, product)}
                                                        >
                                                            -
                                                        </button>
                                                        <span className="quantity">
                                                            {quantities[product.product_id] !== undefined
                                                                ? quantities[product.product_id]
                                                                : Number(product.qty)}
                                                        </span>
                                                        <button
                                                            className="increase-button"
                                                            onClick={() => handleIncrease(product.product_id, product, product.brand)}
                                                        >
                                                            +
                                                        </button>
                                                        {errorQtys[product.product_id] && (
                                                            <p className="error-message-cart-qty" style={{ color: 'red' }}>
                                                                {errorQtys[product.product_id]}
                                                            </p>
                                                        )}
                                                        <div>
                                                            <button
                                                                className="add-cart-button"
                                                                onClick={() => handleGoToCart(product)}
                                                            >
                                                                Go to Cart
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <button
                                                            className="sell-now-button"
                                                            onClick={() => handleAddToCartClick(product.product_id, product)}
                                                        >
                                                            Add to cart
                                                        </button>
                                                        <button
                                                            className="sell-now-button"
                                                            onClick={() => handleSellNowClick(product.product_id, product)}
                                                        >
                                                            Quick Sell
                                                        </button>
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                </div>
            </main>

            {/* Pincode Popup */}
            {showPincodePopup && (
                <div className="pincode-popup">
                    <div className="popup-content">
                        <h2>Enter Pincode</h2>
                        <input
                            type="text"
                            value={pincode}
                            onChange={(e) => setPincode(e.target.value)}
                            placeholder="Enter your pincode"
                        />
                        <button onClick={() => selectPincode()}>Submit</button>
                        {error && <p className="error">{error}</p>}
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
};

export default SellNowPage;
